import React from 'react'

export default function Imprint() {
    return (
        <div className="imprint">
            <h1>Imprint</h1>
            <ul>
                <li>
                    <strong>Christian Gregor</strong>
                </li>
                <li>
                    <strong>VAT ID: DE249761723</strong>
                </li>
                <li>
                    Richardplatz 21
                </li>
                <li>
                    12055 Berlin
                </li>
                <li>
                    Germany
                </li>
                <li>
                    <a href="mailto:grgr@3motic.com">
                        grgr@3motic.com
                    </a>
                </li>
            </ul>
        </div>
    )
}

